import { Button, Drawer, notification, Row, Space } from 'antd';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Radio2, Select1, Select2, SelectMultiple, Text2, TextArea1 } from '../../../../Components/FormComponents/InputFields';
import { AssetRequisitionApi } from '../../../../Services/GeoTag';
import { useNavigate } from 'react-router-dom';
import { checkPleaseLogin } from '../../../../Services/GeneralFunctions';

export default function AssetReq({ open, onClose, defaultValues, getEmployeesData, idAsset }) {
    const navigate = useNavigate();

    const { control, errors, handleSubmit, reset, setValue } = useForm();
    const [api, contextHolder] = notification.useNotification();


    const onSubmit = async (val) => {
        const res = await checkPleaseLogin(navigate);
        if (res) {
            return;
        }

        console.log(val);
        try {
            const data = await AssetRequisitionApi(idAsset, val);

            if (data.data.message === 'Please Login.' || data.data.message === 'Invalid Access Token') {
                navigate('/auth');
            }

            if (data.data.success) {
                api.success({
                    message: data.data.message,
                    placement: 'top'
                });
                getEmployeesData()
                onClose();
            }
            else {
                api.error({
                    message: data.data.message,
                    placement: 'top'
                });
            }
        }
        catch (err) {
            api.error({
                message: err.message,
                placement: 'top'
            });
        }
    }

    useEffect(() => reset(), [onClose]);

    useEffect(() => {
        console.log(defaultValues, "anshul");
        setValue('system', defaultValues?.requirements?.asset_type);
        setValue('os', defaultValues?.requirements?.operating_system);

        setValue('email_group', defaultValues?.requirements?.email_groups);
        setValue('officialEmail', defaultValues?.requirements?.official_email);

        setValue('msOfficeAccess', defaultValues?.requirements?.msoffice_access);
        setValue('photocopyMachineAccess', defaultValues?.requirements?.photocopy_access);

        setValue('CiscoVpn', defaultValues?.requirements?.cisco_vpn);
        setValue('SSlVpn', defaultValues?.requirements?.ssl_vpn);
        setValue('sapAccess', defaultValues?.requirements?.sap_account);
        setValue('accessCard', defaultValues?.requirements?.access_card);
        setValue('anySpfSoft', defaultValues?.requirements?.any_specific_software);
    }, [open])

    return (
        <>
            {contextHolder}
            <Drawer
                title="Add Asset Requisition"
                onClose={onClose}
                open={open}
                contentWrapperStyle={{ width: '100vw' }}
                bodyStyle={{
                    paddingBottom: 80,

                }}
                footer={
                    <Space size='middle'>
                        <Button size='large' onClick={onClose}>Cancel</Button>
                        <Button size='large' onClick={handleSubmit(onSubmit)} type="primary">
                            Submit
                        </Button>
                    </Space>
                }
                footerStyle={{ textAlign: 'right' }}
            >
                <Row>
                    <Select1 control={control} errors={errors} id='system' name='System' options={[
                        { label: 'Laptop', value: "laptop" },
                        { label: 'Desktop', value: "desktop" },
                        { label: 'Mobile Device', value: "mobile" },
                    ]} />
                    <Select1 control={control} errors={errors} id='os' name='Operating Syatem' defaultopt="Windows" options={[
                        { label: 'Linux', value: "linux" },
                        { label: 'MAC', value: "mac" },
                        { label: 'Windows', value: "windows" },
                    ]} />
                    <SelectMultiple control={control} errors={errors} id='email_group' name='Email-Group' options={[
                        { label: 'all@djtfintech.com', value: "all@djtfintech.com" },
                        { label: 'all@djtinsurance.in', value: "all@djtinsurance.in" },
                        { label: 'djtretailers_ho@djtretailers.com', value: "djtretailers_ho@djtretailers.com" },
                        { label: 'deerika_ggn51@deerika.in', value: "deerika_ggn51@deerika.in" },
                        { label: 'all@djtcorp.in ', value: "all@djtcorp.in" },


                    ]} />
                    <Radio2 control={control} errors={errors} id='officialEmail' name='Official Email' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />
                    <Radio2 control={control} errors={errors} id='msOfficeAccess' name='MS office access' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />


                    <Radio2 control={control} errors={errors} id='photocopyMachineAccess' name='Photocopy Machine Access' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />

                    <Radio2 control={control} errors={errors} id='CiscoVpn' name='Cisco Vpn' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />
                    <Radio2 control={control} errors={errors} id='SSlVpn' name='SSL Vpn' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />
                    <Radio2 control={control} errors={errors} id='sapAccess' name='SAP Access' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />
                    <Radio2 control={control} errors={errors} id='accessCard' name='Access Card' options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                    ]} />
                    <TextArea1 control={control} errors={errors} id='anySpfSoft' name='Any specific software' />


                </Row>
            </Drawer>
        </>
    );
};